module.exports = __webpack_public_path__ + "static/1-8089d21c865360e61228453155333248.jpg";